module.exports = __webpack_public_path__ + "static/media/logo_white.a7a32b51.svg";